import { createAction } from "redux-actions";
import { httpClient } from "../../../api/httpClient";
import {
    urlListarCompromisos,
    urlListarBrokers,
    urlObtenerCliente,
    urlCrearCompromiso,
    urlActualizarCompromiso,
    urlListarLineasNegocios,
    urlListarRamos,
    urlEliminarRamo,
    urlEliminarLineasCliente,
    urlListarActividadesEconomicas,
    urlListarAseguradoras,
    urlListarGirosNegocio,
    urlConfiguracion,
    urlValidarDuplicidad,
    urlListarSucursales,
    urlConsultarPolizasVigentes
} from "../api/urls";

// Action Types con Namespace
export const COMPROMISOS_LOADING = "COMPROMISOS/LOADING";
export const COMPROMISOS_HAS_ERRORED = "COMPROMISOS/HAS_ERRORED";

export const SET_DATA_COMPROMISO = "COMPROMISOS/SET_DATA_COMPROMISO";
export const LIMPIAR_DATOS_COMPROMISOS = "COMPROMISOS/LIMPIAR_DATOS_COMPROMISOS";

export const SET_BROKERS = "COMPROMISOS/SET_BROKERS";

export const SET_DATOS_NUEVO_COMPROMISO = "COMPROMISOS/SET_DATOS_NUEVO_COMPROMISO";
export const LIMPIAR_NUEVO_COMPROMISO = "COMPROMISOS/LIMPIAR_NUEVO_COMPROMISO";

export const GUARDAR_COMPROMISO_LOADING = "COMPROMISOS/GUARDAR_COMPROMISO_LOADING";
export const GUARDAR_COMPROMISO_ERROR = "COMPROMISOS/GUARDAR_COMPROMISO_ERROR";

export const CONSULTAR_CLIENTE_LOADING = "COMPROMISOS/CONSULTAR_CLIENTE_LOADING";
export const CONSULTAR_CLIENTE_ERROR = "COMPROMISOS/CONSULTAR_CLIENTE_ERROR";


// Action Creators con Redux-Actions
export const compromisosIsLoading = createAction(COMPROMISOS_LOADING);
export const compromisoHasErrored = createAction(COMPROMISOS_HAS_ERRORED);
export const setDataCompromisos = createAction(SET_DATA_COMPROMISO);
export const limpiarDatosCompromisos = createAction(LIMPIAR_DATOS_COMPROMISOS);
export const setBrokers = createAction(SET_BROKERS);
export const setDatosNuevoCompromiso = createAction(SET_DATOS_NUEVO_COMPROMISO);
export const limpiarNuevoCompromiso = createAction(LIMPIAR_NUEVO_COMPROMISO);
export const guardarCompromisoLoading = createAction(GUARDAR_COMPROMISO_LOADING);
export const guardarCompromisoError = createAction(GUARDAR_COMPROMISO_ERROR);
export const consultarClienteLoading = createAction(CONSULTAR_CLIENTE_LOADING);
export const consultarClienteError = createAction(CONSULTAR_CLIENTE_ERROR);

// --- THUNKS ---

/**
 * Lista todos los compromisos guardados en base de datos.
 */

export const listarCompromisos = (filtros = {}) => async (dispatch) => {
    dispatch(compromisosIsLoading(true));
    dispatch(compromisoHasErrored(null));
    try {

        const response = await httpClient.post(urlListarCompromisos, filtros, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        const payload = response && response.data && response.data.success !== undefined
            ? response.data
            : response;
        const datos = payload && Array.isArray(payload.data)
            ? payload.data
            : [];

        if (payload && payload.success === true) {
            dispatch(setDataCompromisos(datos));
            return datos;
        } else {
            dispatch(compromisoHasErrored((payload && payload.message) || "Error desconocido al listar compromisos."));
        }
    } catch (error) {
        dispatch(compromisoHasErrored("Excepción al listar compromisos: " + error.message));
    } finally {
        dispatch(compromisosIsLoading(false));
    }

    return [];
};

export const listarBrokers = (aglutinador) => async (dispatch, getState) => {

    try {

        const response = await httpClient.get(`${urlListarBrokers}&aglutinador=${aglutinador}`);

        const payload =
            response &&
                response.data &&
                response.data.success !== undefined
                ? response.data
                : response;

        const datos =
            payload && Array.isArray(payload.data)
                ? payload.data
                : [];

        if (payload && payload.success === true) {

            dispatch(setBrokers(datos));

            return datos;
        }

        return [];

    } catch (error) {

        console.error(
            "Error al listar brokers:",
            error
        );

        return [];
    }
};

export const consultarCliente = (
    tipoIdentificacion,
    numeroIdentificacion
) => async (dispatch) => {

    try {

        dispatch(consultarClienteLoading(true));
        dispatch(consultarClienteError(null));


        const response = await httpClient.get(
            `${urlObtenerCliente}&tipoIdentificacion=${tipoIdentificacion}&numeroIdentificacion=${numeroIdentificacion}`
        );

        const payload =
            response &&
                response.data &&
                response.data.success !== undefined
                ? response.data
                : response;

        if (payload && payload.success === true) {

            const cliente =
                payload.data || null;

            return cliente;
        }

        return null;

    } catch (error) {

        dispatch(
            consultarClienteError(
                error.message ||
                "Ocurrió un error al consultar el cliente"
            )
        );

        return null;
    } finally {
        dispatch(
            consultarClienteLoading(false)
        );
    }
};


export const guardarCompromiso = (datos) =>
    async (dispatch, getState) => {

        dispatch(guardarCompromisoLoading(true));
        dispatch(guardarCompromisoError(null));

        try {

            const state = getState();

            const nuevoCompromiso =
                state.dataCompromisos &&
                    state.dataCompromisos.nuevoCompromiso
                    ? state.dataCompromisos.nuevoCompromiso
                    : {};

            const idCompromiso =
                nuevoCompromiso.idCompromiso;

            let response;

            /*
             * Si todavía no existe compromiso:
             * crear.
             */
            if (!idCompromiso) {

                response = await httpClient.post(
                    urlCrearCompromiso,
                    datos,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

            } else {

                /*
                 * Si ya existe:
                 * actualizar.
                 */
                response = await httpClient.put(
                    `${urlActualizarCompromiso}&id=${idCompromiso}`,
                    datos,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
            }

            const payload =
                response &&
                    response.data &&
                    response.data.success !== undefined
                    ? response.data
                    : response;

            if (
                payload &&
                payload.success === true
            ) {

                /*
                 * En POST esperamos el ID.
                 * En PUT puede que no vuelva a enviarse.
                 */
                const idGuardado =
                    payload.data &&
                        payload.data.idCompromiso
                        ? payload.data.idCompromiso
                        : idCompromiso;

                return {
                    success: true,
                    idCompromiso: idGuardado
                };
            }

            dispatch(
                guardarCompromisoError(
                    payload && payload.message
                        ? payload.message
                        : "No fue posible guardar el compromiso"
                )
            );

            return {
                payload: payload,
                success: false,
                idCompromiso: null
            };

        } catch (error) {

            dispatch(
                guardarCompromisoError(
                    error.message ||
                    "Ocurrió un error al guardar el compromiso"
                )
            );

            return {
                success: false,
                idCompromiso: null
            };

        } finally {

            dispatch(
                guardarCompromisoLoading(false)
            );
        }
    };

export const listarLineasNegocio = () => async () => {
    try {

        const response =
            await httpClient.get(
                `${urlListarLineasNegocios}`
            );

        return response.data;

    } catch (error) {

        console.error(
            "Error listando líneas de negocio",
            error
        );

        throw error;
    }
};

export const listarRamos =
    (lnCodigo) =>
        async () => {

            try {

                const response =
                    await httpClient.get(
                        `${urlListarRamos}&lineaCodigo=${lnCodigo}`
                    );

                return response.data;

            } catch (error) {

                console.error(
                    "Error listando ramos",
                    error
                );

                throw error;
            }
        };

export const eliminarRamoCompromiso =
    (
        idCompromiso,
        lnCodigo,
        rmCodigo
    ) =>
        async () => {

            try {

                const response =
                    await httpClient.delete(
                        `${urlEliminarRamo}&id=${idCompromiso}&lnCodigo=${lnCodigo}&rmCodigo=${rmCodigo}`

                    );

                return response.data;

            } catch (error) {

                console.error(
                    "Error eliminando ramo",
                    error
                );

                throw error;
            }
        };

export const eliminarLineasCliente =
    (
        idCompromiso,
    ) =>
        async () => {

            try {

                const response =
                    await httpClient.delete(
                        `${urlEliminarLineasCliente}&id=${idCompromiso}`

                    );

                return response.data;

            } catch (error) {

                console.error(
                    "Error eliminando lineas",
                    error
                );

                throw error;
            }
        };

export const listarAseguradoras = () => async () => {

    try {

        const response =
            await httpClient.get(
                `${urlListarAseguradoras}`
            );

        return response;

    } catch (error) {

        console.error(
            "Error listando aseguradoras",
            error
        );

        throw error;
    }
};

export const listarGirosNegocio = () => async () => {
    try {

        const response =
            await httpClient.get(
                `${urlListarGirosNegocio}`
            );

        return response;

    } catch (error) {

        console.error(
            "Error listando giros de negocio",
            error
        );

        throw error;
    }
};
export const listarActividadesEconomicas = () => async () => {

    try {

        const response =
            await httpClient.get(
                `${urlListarActividadesEconomicas}`
            );

        return response;

    } catch (error) {

        console.error(
            "Error listando actividades economicas",
            error
        );

        throw error;
    }
};

export const configuracionCompromisos = () => async () => {

    try {

        const response =
            await httpClient.get(
                `${urlConfiguracion}`
            );

        return response;

    } catch (error) {

        console.error(
            "Error listando configuraciones de compromisos",
            error
        );

        throw error;
    }
};

export const validarDuplicidadCompromiso =
    (
        numeroIdentificacion,
        ramos,
        idCompromiso
    ) =>
        async () => {

            try {

                const response =
                    await httpClient.get(
                        `${urlValidarDuplicidad}` +
                        `&numeroIdentificacion=${encodeURIComponent(numeroIdentificacion)}` +
                        `&ramos=${encodeURIComponent(JSON.stringify(ramos))}` +
                        `&idCompromiso=${encodeURIComponent(idCompromiso || "")}`
                    );

                return response;

            } catch (error) {

                console.error(
                    "Error validando duplicidad",
                    error
                );

                throw error;
            }
        };

export const listarSucursales = () => async () => {

    try {

        const response =
            await httpClient.get(
                `${urlListarSucursales}`
            );

        const payload =
            response &&
                response.data &&
                response.data.success !== undefined
                ? response.data
                : response;

        if (payload && payload.success === true) {

            const sucursales =
                payload.data || null;

            return sucursales;
        }

        return null;

    } catch (error) {

        console.error(
            "Error listando sucursales",
            error
        );

        throw error;
    }
};

export const consultarPolizasVigentes = (
    datos
) => async () => {
    try {
        const response = await httpClient.post(
                    urlConsultarPolizasVigentes,
                    datos,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

        return response;

    } catch (error) {

        console.error(
            "Error consultando pólizas vigentes",
            error
        );

        throw error;
    }
};